import { render, staticRenderFns } from "./scoreruleMod.vue?vue&type=template&id=4d68f9b6&scoped=true&"
import script from "./scoreruleMod.vue?vue&type=script&lang=js&"
export * from "./scoreruleMod.vue?vue&type=script&lang=js&"
import style0 from "./scoreruleMod.vue?vue&type=style&index=0&id=4d68f9b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d68f9b6",
  null
  
)

export default component.exports